import React, { useEffect, useState } from 'react';

import { CardId } from '../api/card';
import { FaresQueryResponse, getFares } from '../api/fare';

import Header from './Header';
import CardForm from './CardForm';
import FareList from './FareList';
import ErrorAlert from './ErrorAlert';
import CardSkeleton from './CardSkeleton';
import Footer from './Footer';

function App(): JSX.Element {
  const [card, setCard] = useState<CardId | null>(null);
  const [result, setResult] = useState<FaresQueryResponse | null>(null);
  const [error, setError] = useState<boolean>(false);
  const isLoading = card !== null && result === null && error !== null;

  useEffect(() => {
    if (card === null) {
      return;
    }
    // Clear previous result and errors
    setResult(null);
    setError(false);

    // Load fares for the given card
    const abortCtrl = new AbortController();
    getFares(card, abortCtrl.signal)
      .then((newResult) => setResult(newResult))
      .catch((err) => {
        setError(true);
        console.error(err); // TODO Better logging
      });
    return () => abortCtrl.abort();
  }, [card]);

  return (
    <div className="font-sans bg-gray-50">
      <div className="min-h-screen max-w-4xl mx-auto px-4 flex flex-col sm:px-6 lg:px-8">
        <Header />
        <main className="mt-6 flex-grow space-y-6">
          <CardForm setCard={setCard} />
          {error ? (
            <ErrorAlert>
              An error occurred. Check the console for details.
            </ErrorAlert>
          ) : null}
          {isLoading ? <CardSkeleton /> : null}
          {result !== null ? (
            result.found ? (
              <FareList fares={result.fares} />
            ) : (
              <ErrorAlert>The given card ID could not be found.</ErrorAlert>
            )
          ) : null}
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default App;
